"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var range_1 = require("./range");
var isAfter = function (d1, d2) { return d1.getTime() > d2.getTime(); };
var createRanges = function (start, ranges, rangesToRemove, end, initialRange) {
    var foundToRemove = rangesToRemove.find(function (r) { return range_1.overlapping(r.range, { start: start, end: end }); });
    if (!foundToRemove) {
        return __spreadArrays(ranges, (isAfter(end, start)
            ? [
                __assign(__assign({}, initialRange), { range: {
                        start: start,
                        end: end,
                    } }),
            ]
            : []));
    }
    var newRanges = __spreadArrays(ranges, (isAfter(foundToRemove.range.start, start)
        ? [
            __assign(__assign({}, initialRange), { range: {
                    start: start,
                    end: foundToRemove.range.start,
                } }),
        ]
        : []));
    return createRanges(foundToRemove.range.end, newRanges, rangesToRemove, end, initialRange);
};
/**
 * Remove list2 ranges from list1
 */
var Remove = function (listToKeep, listToRemove) {
    var listToKeepWithDate = range_1.rangesToRangesDates(listToKeep);
    var listToRemoveWithDate = range_1.rangesToRangesDates(listToRemove);
    var sortedListToRemove = listToRemoveWithDate.sort(function (a, b) { return a.range.start.getTime() - b.range.start.getTime(); });
    var result = listToKeepWithDate.reduce(function (acc, current) {
        var rangesOverlapping = sortedListToRemove.filter(function (ranges) {
            return range_1.overlapping(ranges.range, current.range);
        });
        if (!(rangesOverlapping === null || rangesOverlapping === void 0 ? void 0 : rangesOverlapping.length)) {
            return __spreadArrays(acc, [current]);
        }
        var ranges = createRanges(current.range.start, [], rangesOverlapping, current.range.end, current);
        return __spreadArrays(acc, ranges);
    }, []);
    return result;
};
exports.default = Remove;
